// extracted by mini-css-extract-plugin
export var image = "_gx-1";
export var imageContainer = "_gx-0";